import React from 'react';

const LoadingSpinner = () => (
  <div className="flex justify-center items-center py-20">
    <div className="spinner"></div>
  </div>
);

export default LoadingSpinner;
